"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorldMap = WorldMap;
var d3 = _interopRequireWildcard(require("d3"));
var _lib = require("@a1s/lib");
var _d3Hexgrid = require("d3-hexgrid");
var _react = _interopRequireWildcard(require("react"));
var _simpleStatistics = require("simple-statistics");
var _topojsonClient = require("topojson-client");
var _land110m = _interopRequireDefault(require("world-atlas/land-110m.json"));
var _ = require("../..");
var _animations = require("../../shared/animations");
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable import/namespace */
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 *
 * @alpha
 */
function WorldMap({
  data = [],
  height,
  hexSize = 3,
  testId,
  width
}) {
  // Aceept numbers or strings for the dimension props
  height = (0, _lib.num)(height);
  width = (0, _lib.num)(width);
  const ref = (0, _react.useRef)(null);

  /* eslint-disable @typescript-eslint/no-explicit-any */ // <-- Much of the d3 library isn't typed and will need manual types
  (0, _react.useEffect)(() => {
    if (!ref.current) return;
    const [land] = (0, _topojsonClient.feature)(_land110m.default, _land110m.default.objects.land).features;
    const projection = d3.geoNaturalEarth1().center([0, 0]).rotate([-11.25, 0, 0]).fitSize([width, height], land);
    const path = d3.geoPath().projection(projection);
    const generator = (0, _d3Hexgrid.hexgrid)().extent([width, height])
    // .edgePrecision([0.75])
    .edgePrecision([1]).hexRadius(hexSize).geography(land).projection(projection).pathGenerator(path);
    const hex = generator(data.map(d => {
      const [x, y] = projection([+d.lng, +d.lat]);
      return {
        ...d,
        x,
        y
      };
    }));
    const svg = d3.select(ref.current);
    const counts = hex.grid.layout.map(el => el.datapointsWt).filter(el => el > 0);
    if (counts.length > 0) {
      const ckBreaks = (0, _simpleStatistics.ckmeans)(counts, Math.min(200, counts.length)).map(clusters => clusters[0]);
      const colourScale = d3.scaleThreshold().domain(ckBreaks).range(['#17a2f0', '#0e7afe', '#1a67fe', '#064ef3', '#ffdd03', '#ff8802', '#ff4f00']);
      svg.html(null).append('g').selectAll('.hex').data(hex.grid.layout).enter().append('path').attr('class', 'hex').attr('d', hex.hexagon()).attr('transform', d => `translate(${d.x}, ${d.y})`).style('fill', d => !d.pointDensity ? '#05c4e1' : colourScale(d.pointDensity)).style('stroke', '#fff').style('stroke-width', '0.75px');
    } else {
      svg.html(null).append('g').selectAll('.hex').data(hex.grid.layout).enter().append('path').attr('class', 'hex').attr('d', hex.hexagon()).attr('transform', d => `translate(${d.x}, ${d.y})`).style('fill', '#dddddd').style('stroke', '#fff').style('stroke-width', '0.75px');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, hexSize, ref]);
  /* eslint-enable @typescript-eslint/no-explicit-any */

  return /*#__PURE__*/_react.default.createElement(_styled.StyledBase, {
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement("svg", {
    ref: ref,
    viewBox: `0 0 ${width} ${height}`,
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%"
  }));
}

//
// Utility components
// -------------------------------------------------------------------------------------------------

WorldMap.Loadable = Loadable;
function Loadable({
  data,
  loading,
  ...props
}) {
  const isLoading = (0, _.useLoadable)(loading);
  if (!isLoading && data) return /*#__PURE__*/_react.default.createElement(WorldMap, _extends({
    data: data
  }, props));
  return /*#__PURE__*/_react.default.createElement(_.Box, {
    css: {
      animation: `${_animations.pulse} 1.5s linear infinite`,
      userSelect: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(WorldMap, _extends({
    data: []
  }, props)));
}